import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { PageLinksModule } from '@features/page-links/page-links.module';

import { ProductModule } from '@features/product/product.module';
import { SliderModule } from '@features/slider/slider.module';
import { SpotHeadlineComponent } from '@features/spots/spot-headline/spot-headline.component';
import { MapStoresToOptions } from '@features/spots/newsletter/map-stores-to-options.pipe';
import { recipeComponents } from '@features/spots/recipe/recipe-components';
import { blockListSpotComponents } from '@features/spots/umbraco-block-list-spot/block-list-spot-components';
import { GenericBlockListSpotDirective } from '@features/spots/umbraco-block-list-spot/block-list-spot-generic.directive';
import { BlockListSpotsComponent } from '@features/spots/umbraco-block-list-spot/block-list-spots.component';
import { TouchPointModule } from '@features/touch-point/touch-point.module';
import { FormElementsModule } from '@shared/form-elements/form-elements.module';
import { SharedModule } from '@shared/shared.module';

import { AddIndexToSpotDataPipe } from './add-index-to-spot-data.pipe';
import { SameDayDeliveryModule } from '@shared/same-day-delivery/same-day-delivery.module';

import { ThirdPartyModule } from '@features/third-party/third-party.module';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        SharedModule,
        SliderModule,
        ProductModule,
        TouchPointModule,
        FormElementsModule,
        PageLinksModule,
        SameDayDeliveryModule,
        ThirdPartyModule,
        TranslateModule,
        BlockListSpotsComponent,
        GenericBlockListSpotDirective,
        BlockListSpotsComponent,
        MapStoresToOptions,
        AddIndexToSpotDataPipe,
        SpotHeadlineComponent,
        ...recipeComponents,
        ...blockListSpotComponents
    ],
    exports: [BlockListSpotsComponent, ...blockListSpotComponents]
})
export class BlockListSpotsModule {}
